export default "__VITE_ASSET__JPDmbqct__"